import { useMap } from "react-leaflet";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { setSourceLocationJustSet } from "../../redux/map/map.actions";
import {
  selectMapLeftOverlayShow,
  selectMapLevel,
} from "../../redux/map/map.selectors";
import {
  selectNewRequestSelectedCity,
  selectNewRequestSelectedDistrict,
  selectNewRequestSelectedProvince,
  selectNewRequestSelectionLevel,
  selectNewRequestSourceLocation,
} from "../../redux/newRequest/newRequest.selectors";
import { selectMapSourceLoacationJustSet } from "../../redux/map/map.selectors";

const FlyTo = ({
  selectNewRequestSelectedProvince,
  selectNewRequestSelectionLevel,
  selectNewRequestSelectedCity,

  selectNewRequestSelectedDistrict,

  selectMapLevel,
  selectNewRequestSourceLocation,

  setSourceLocationJustSet,
  selectMapSourceLoacationJustSet,
}) => {
  const map = useMap();

  // map.addEventListener("click", () => alert("hi"));

  // console.log(selectNewRequestSelectedProvince);
  // debugger;
  const customFlyTo = (lat, lng, zoom) => {
    map.flyTo(
      {
        lat,
        lng,
      },
      zoom
    );
  };

  if (selectMapLevel === 2) return null;

  // alert("next");
  if (
    selectNewRequestSelectionLevel === 1 &&
    selectNewRequestSelectedProvince.plat
  ) {
    // debugger;
    customFlyTo(
      selectNewRequestSelectedProvince.plat,
      selectNewRequestSelectedProvince.plong,
      10
    );
    return null;
    // alert("1");
  }

  if (
    selectNewRequestSelectionLevel === 2 &&
    selectNewRequestSelectedCity.lat
  ) {
    customFlyTo(
      selectNewRequestSelectedCity.lat,
      selectNewRequestSelectedCity.long,
      13
    );
    return null;
    // alert("2");
  }

  if (
    selectNewRequestSelectionLevel === 3 &&
    selectNewRequestSelectedDistrict.lat
  ) {
    customFlyTo(
      selectNewRequestSelectedDistrict.lat,
      selectNewRequestSelectedDistrict.long,
      17
    );
    // alert("3");
    // return null;
  }

  // debugger;

  return null;
};

// const mapDispatchToProps = (dispatch) => ({
//   setCenterOfMap: (x) => dispatch(setCenterOfMap(x)),

//   fetchCenterOfMapAddressAsync: (x) =>
//     dispatch(fetchCenterOfMapAddressAsync(x)),
//   fetchCenterOfMapAddressStart: () => dispatch(fetchCenterOfMapAddressStart()),

//   toggleMapOverlayLeftShow: (x) => dispatch(toggleMapOverlayLeftShow(x)),
// });

const mapStateToProps = createStructuredSelector({
  selectMapLeftOverlayShow: selectMapLeftOverlayShow,
  selectNewRequestSelectedProvince: selectNewRequestSelectedProvince,
  selectNewRequestSelectionLevel: selectNewRequestSelectionLevel,

  selectNewRequestSelectedCity: selectNewRequestSelectedCity,
  selectNewRequestSelectedDistrict: selectNewRequestSelectedDistrict,

  selectMapLevel: selectMapLevel,
  selectNewRequestSourceLocation: selectNewRequestSourceLocation,

  selectMapSourceLoacationJustSet: selectMapSourceLoacationJustSet,
});

const mapDispatchToProps = (dispatch) => ({
  setSourceLocationJustSet: (x) => dispatch(setSourceLocationJustSet(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FlyTo);
